/**
 * 특정 국가에서 정렬 순서가 다를 때 
 * - countryItem: {name: string(국가명), index: number} // 단, 해당 국가가 포함된 모든 게임들은 {name: string, index: number} 로 지정해야함
 * 
 * 국가별 정렬 순서 동일 
 * - countryItem: string
 * 
 * 특정 국가에서 l10nKey값이 다를 때
 * - countryItem: {name: string(국가명), l10nKey: string}
 */

import { AREA_TYPE, COUNTRY_CODE } from './index';

export const GAME = {
    TL: 'tl',
    LW: 'lineagew',
    BNS2: 'bns2',
    TRICKSTERM: 'tricksterm',
    H3: 'h3',
    L2M: 'lineage2m',
    L2MNU: 'lineage2mnaeu',
    L2MRU: 'lineage2mru',
    LM: 'lineagem',
    H2: 'h2',
    BNS: 'bns',
    AION: 'aion',
    LOVEBEAT: 'lovebeat',
    L2: 'lineage2',
    LINEAGE: 'lineage',
    JMM: '雀龍門M',
    JIN_JANRYUMON: '真_雀龍門',
    PUZZUP: 'puzzup',
    BATTLE_CRUSH: "BATTLE CRUSH",
    HOYEON: 'hoyeon'
};

const CC = COUNTRY_CODE;
export const NCK_GAMES = [
    {
        name: [GAME.HOYEON],
        l10nKey: 'hoyeon',
        app: 'pc,apple,android',
        url: 'https://hoyeon.plaync.com',
        urlRc: 'https://rc-hoyeon.plaync.com',
        country: [CC.NC, CC.KR, CC.TW, CC.JP]
    },
    {
        name: [GAME.BATTLE_CRUSH],
        l10nKey: 'battleCrush',
        app: 'apple,android,nintendo,steam',
        url: 'https://battlecrush.plaync.com',
        urlRc: 'https://rc-battlecrush.plaync.com',
        country: [CC.NC, CC.KR, CC.TW, CC.JP, CC.ID, CC.TH, CC.MY, CC.SA, CC.AE, CC.QA, CC.HK, CC.SG, CC.PH, CC.IT, CC.ES, CC.CL, CC.NO, CC.SE, CC.IE, CC.PT, CC.FI, CC.DK, CC.US, CC.CH, CC.CA, CC.BR, CC.AR, CC.GB, CC.PE, CC.MX, CC.FR, CC.DE, CC.UA, CC.PL, CC.GR, CC.BY, CC.LT, CC.IL, CC.KW, CC.AT, CC.KZ, CC.UZ, CC.AZ, CC.MD, CC.AM, CC.MO, CC.CO, CC.EC, CC.TR, CC.NL, CC.RO, CC.EG, CC.ZA, CC.AU, CC.PK, CC.IN, CC.BE, CC.CZ, CC.NZ, CC.LU, CC.HU, CC.LV, CC.SL, CC.SK, CC.BG, CC.RS, CC.BA, CC.HR, CC.MK, CC.DZ, CC.TN, CC.MA, CC.GH, CC.NG, CC.TZ, CC.KE, CC.IQ, CC.JO, CC.LB, CC.YE, CC.BH, CC.OM, CC.NP, CC.KH, CC.LK, CC.KG, CC.PY, CC.HN, CC.GT, CC.CR, CC.SV, CC.PA, CC.VE, CC.UY, CC.BO, CC.JM, CC.TT, CC.DO, CC.MT, CC.CY, CC.EE]
    },
    {
        name: [GAME.PUZZUP],
        l10nKey: 'puzzup',
        app: 'apple,android',
        url: 'https://puzzupamitoi.plaync.com',
        urlRc: 'https://rc-puzzupamitoi.plaync.com',
        country: [CC.KR, CC.NC, CC.BR, CC.MX, CC.AR, 
            CC.CO, CC.PE, CC.CL, CC.EC, CC.FR, 
            CC.ES, CC.DE, CC.IT, CC.NL, CC.RO,
            CC.CH, CC.AT, CC.IN, CC.PK, CC.TR, 
            CC.EG, CC.ZA, CC.AU, CC.US, CC.CA,
            CC.GB, CC.PH, CC.ID, CC.TH, CC.TW,
            CC.MY, CC.JP, CC.KR, CC.HK, CC.SG,
            CC.SA, CC.IL, CC.SE
        ]
    },
    {
        name: [GAME.TL],
        l10nKey: 'tl',
        app: 'pc',
        url: 'https://tl.plaync.com',
        urlRc: 'https://rc-tl.plaync.com',
        country: [CC.KR, CC.NC]
    },
    {
        name: [GAME.LW],
        l10nKey: 'lineagew',
        app: 'pc,apple,android',
        url: 'https://lineagew.plaync.com',
        urlRc: 'https://rc-lineagew.plaync.com',
        country: [CC.KR, CC.NC, {name: CC.TW, index: 2}, {name: CC.JP, index: 2}, CC.ID, 
            CC.TH, CC.MY, CC.SA, CC.AE, CC.QA, 
            CC.HK, CC.SG, CC.PH]
    },
    {
        name: [GAME.BNS2],
        l10nKey: 'bns2',
        app: 'pc,apple,android',
        url: 'https://bns2.plaync.com',
        urlRc: 'https://rc-bns2.plaync.com',
        country: [CC.KR, CC.NC, {name: CC.JP, index: 1, l10nKey: 'BnS2'}, {name: CC.TW, index: 1, l10nKey: 'BnS2'}],
    },
    {
        name: [GAME.L2M],
        l10nKey: 'lineage2m',
        app: 'pc,apple,android',
        url: 'https://lineage2m.plaync.com',
        urlRc: 'https://rc-lineage2m.plaync.com',
        country: [CC.KR, CC.NC, CC.RU, CC.AE, CC.US, 
            CC.CA, CC.DE, CC.GB, CC.FR, CC.BR, 
            CC.IT, CC.ES, CC.CL, CC.NO, CC.SE, 
            CC.IE, CC.PT, CC.FI, CC.DK, CC.CH,
            CC.AR, CC.PE, CC.MX, CC.KZ, CC.UZ, 
            CC.AZ, CC.GE, CC.MD, CC.AM, CC.UA,
            CC.PL, CC.GR, CC.BY, CC.LT, CC.IL, 
            CC.KW, CC.AT]
    },
    {
        name: [GAME.L2MNU],
        l10nKey: 'lineage2m',
        app: 'pc,apple,android',
        url: 'https://lineage2m.plaync.com',
        urlRc: 'https://rc-lineage2m.plaync.com',
        country: []
    },
    {
        name: [GAME.L2MRU],
        l10nKey: 'lineage2m',
        app: 'pc,apple,android',
        url: 'https://lineage2m.plaync.com',
        urlRc: 'https://rc-lineage2m.plaync.com',
        country: []
    },
    {
        name: [GAME.LM],
        l10nKey: 'lineagem',
        app: 'pc,apple,android',
        url: 'https://lineagem.plaync.com',
        urlRc: 'https://rc-lineagem.plaync.com',
        country: [CC.KR, CC.NC]
    },
    {
        name: [GAME.BNS],
        l10nKey: 'bns',
        app: 'pc',
        url: 'https://bns.plaync.com',
        urlRc: 'https://rc-bns.plaync.com',
        country: [CC.KR, CC.NC]
    },
    {
        name: [GAME.AION],
        l10nKey: 'aion',
        app: 'pc',
        url: 'https://aion.plaync.com',
        urlRc: 'https://rc-aion.plaync.com',
        country: [CC.KR, CC.NC]
    },
    {
        name: [GAME.LOVEBEAT],
        l10nKey: 'lovebeat',
        app: 'pc',
        url: 'https://lovebeat.plaync.com',
        urlRc: 'https://rc-lovebeat.plaync.com',
        country: [CC.KR, CC.NC]
    },
    {
        name: [GAME.L2],
        l10nKey: 'lineage2',
        app: 'pc',
        url: 'https://lineage2.plaync.com',
        urlRc: 'https://rc-lineage2.plaync.com',
        country: [CC.KR, CC.NC]
    },
    {
        name: [GAME.LINEAGE],
        l10nKey: 'lineage',
        app: 'pc',
        url: 'https://lineage.plaync.com',
        urlRc: 'https://rc-lineage.plaync.com',
        country: [CC.KR, CC.NC]
    }
];

export const NCT_GAMES = [
    {
        name: [GAME.HOYEON],
        l10nKey: 'hoyeon',
        app: 'pc,apple,android',
        url: 'https://hoyeon.plaync.com',
        urlRc: 'https://rc-hoyeon.plaync.com',
        country: []
    },
    {
        name: [GAME.PUZZUP],
        l10nKey: 'puzzup',
        app: 'apple,android',
        url: 'https://puzzupamitoi.plaync.com',
        urlRc: 'https://rc-puzzupamitoi.plaync.com',
        country: []
    },
    {
        name: [GAME.BNS2],
        l10nKey: 'BnS2',
        app: 'pc,apple,android',
        url: 'https://bns2.plaync.com/',
        urlRc: 'https://rc-bns2.plaync.com/',
        country: [],
    },
    {
        name: [GAME.LW],
        l10nKey: 'lineagew',
        app: 'pc,apple,android',
        url: 'https://lineagew.plaync.com/tw/index',
        urlRc: 'https://rc-lineagew.plaync.com/tw/index',
        country: []
    },
    {
        name: [GAME.L2M],
        l10nKey: 'lineage2m',
        app: 'pc,apple,android',
        url: 'https://tw.ncsoft.com/lineage2m/',
        urlRc: 'https://rc-tw.ncsoft.com/lineage2m/',
        country: []
    },
    {
        name: [GAME.BNS],
        l10nKey: 'NCTBns',
        app: 'pc',
        url: 'https://tw.ncsoft.com/bns/index',
        urlRc: 'https://rc-tw.ncsoft.com/bns/index',
        country: []
    },
    {
        name: [GAME.AION],
        l10nKey: 'NCTAion',
        app: 'pc',
        url: 'https://tw.ncsoft.com/aion/',
        urlRc: 'https://rc-tw.ncsoft.com/aion/',
        country: []
    },
    {
        name: [GAME.L2],
        l10nKey: 'NCTLineage2',
        app: 'pc',
        url: 'https://tw.ncsoft.com/lineage2/',
        urlRc: 'https://rc-tw.ncsoft.com/lineage2/',
        country: []
    }
];

export const NCJ_GAMES = [
    {
        name: [GAME.HOYEON],
        l10nKey: 'hoyeon',
        app: 'pc,apple,android',
        url: 'https://hoyeon.plaync.com',
        urlRc: 'https://rc-hoyeon.plaync.com',
        country: []
    },
    {
        name: [GAME.PUZZUP],
        l10nKey: 'puzzup',
        app: 'apple,android',
        url: 'https://puzzupamitoi.plaync.com',
        urlRc: 'https://rc-puzzupamitoi.plaync.com',
        country: []
    },
    {
        name: [GAME.L2M],
        l10nKey: 'lineage2m',
        app: 'pc,apple,android',
        url: 'https://lineage2m.ncsoft.jp/',
        country: []
    },
    {
        name: [GAME.JMM],
        l10nKey: 'NCJJmm',
        app: 'apple,android',
        url: 'https://jmm.ncsoft.jp/',
        country: []
    },
    {
        name: [GAME.LM],
        l10nKey: 'lineagem',
        app: 'apple,android',
        url: 'https://lineagem-jp.com/',
        country: []
    },
    {
        name: [GAME.BNS],
        l10nKey: 'BnS',
        app: 'pc',
        url: 'https://www.ncsoft.jp/bns/',
        country: []
    },
    {
        name: [GAME.AION],
        l10nKey: 'AION',
        app: 'pc',
        url: 'https://www.ncsoft.jp/aion/',
        country: []
    },
    {
        name: [GAME.L2],
        l10nKey: 'NCJLineage2',
        app: 'pc',
        url: 'https://www.ncsoft.jp/lineage2/',
        country: []
    },
    {
        name: [GAME.LINEAGE],
        l10nKey: 'lineage',
        app: 'pc',
        url: 'https://www.ncsoft.jp/lineage/',
        country: []
    }
];

export const NCA_EN_US_GAMES = [
    {
        name: [GAME.PUZZUP],
        l10nKey: 'puzzup',
        app: 'pc,apple,android',
        url: 'https://puzzupamitoi.plaync.com',
        urlRc: 'https://rc-puzzupamitoi.plaync.com',
        country: []
    },
    {
        name: [GAME.L2M],
        l10nKey: 'lineage2m',
        app: 'pc,apple,android',
        url: 'https://lineage2m.plaync.com/naeu',
        urlRc: 'https://rc-lineage2m.plaync.com/naeu',
        country: []
    },
    {
        name: [GAME.BNS],
        l10nKey: 'BnS',
        app: 'pc',
        url: 'https://www.bladeandsoul.com/en-us',
        urlRc: 'https://rc.bladeandsoul.com/en-us',
        country: []
    },
    {
        name: [GAME.AION],
        l10nKey: 'AION',
        app: 'pc',
        url: 'https://www.aiononline.com/en-us',
        urlRc: 'https://rc.aiononline.com/en-us',
        country: []
    },
    {
        name: [GAME.L2],
        l10nKey: 'lineage2',
        app: 'pc',
        url: 'https://www.lineage2.com/en-us',
        urlRc: 'https://rc.lineage2.com/en-us',
        country: []
    },
];

export const NCA_EN_GB_GAMES = [
    {
        name: [GAME.PUZZUP],
        l10nKey: 'puzzup',
        app: 'pc,apple,android',
        url: 'https://puzzupamitoi.plaync.com',
        urlRc: 'https://rc-puzzupamitoi.plaync.com',
        country: []
    },
    {
        name: [GAME.L2M],
        l10nKey: 'lineage2m',
        app: 'pc,apple,android',
        url: 'https://lineage2m.plaync.com/naeu',
        urlRc: 'https://rc-lineage2m.plaync.com/naeu',
        country: []
    },
    {
        name: [GAME.BNS],
        l10nKey: 'BnS',
        app: 'pc',
        url: 'https://www.bladeandsoul.com/en-gb',
        urlRc: 'https://rc.bladeandsoul.com/en-gb',
        country: []
    },
];

export const NCA_DE_GAMES = [
    {
        name: [GAME.PUZZUP],
        l10nKey: 'puzzup',
        app: 'pc,apple,android',
        url: 'https://puzzupamitoi.plaync.com',
        urlRc: 'https://rc-puzzupamitoi.plaync.com',
        country: []
    },
    {
        name: [GAME.L2M],
        l10nKey: 'lineage2m',
        app: 'pc,apple,android',
        url: 'https://lineage2m.plaync.com/naeu',
        urlRc: 'https://rc-lineage2m.plaync.com/naeu',
        country: []
    },
    {
        name: [GAME.BNS],
        l10nKey: 'BnS',
        app: 'pc',
        url: 'https://www.bladeandsoul.com/de',
        urlRc: 'https://rc.bladeandsoul.com/de',
        country: []
    },
];

export const NCA_FR_GAMES = [
    {
        name: [GAME.PUZZUP],
        l10nKey: 'puzzup',
        app: 'pc,apple,android',
        url: 'https://puzzupamitoi.plaync.com',
        urlRc: 'https://rc-puzzupamitoi.plaync.com',
        country: []
    },
    {
        name: [GAME.L2M],
        l10nKey: 'lineage2m',
        app: 'pc,apple,android',
        url: 'https://lineage2m.plaync.com/naeu',
        urlRc: 'https://rc-lineage2m.plaync.com/naeu',
        country: []
    },
    {
        name: [GAME.BNS],
        l10nKey: 'BnS',
        app: 'pc',
        url: 'https://www.bladeandsoul.com/fr',
        urlRc: 'https://rc.bladeandsoul.com/fr',
        country: []
    },
];

export const GAME_AREA_MAP = {
    [AREA_TYPE.NCK]: NCK_GAMES,
    [AREA_TYPE.NCT]: NCT_GAMES,
    [AREA_TYPE.NCJ]: NCJ_GAMES,
    [AREA_TYPE.NCA_EN_US]: NCA_EN_US_GAMES,
    [AREA_TYPE.NCA_EN_GB]: NCA_EN_GB_GAMES,
    [AREA_TYPE.NCA_DE]: NCA_DE_GAMES,
    [AREA_TYPE.NCA_FR]: NCA_FR_GAMES,
};
